import { useLegalStore } from '@/stores/legal';
import { showToast } from '@/utils/swal';

/**
 * Call this before anything that uses the AI features. It returns false when
 * the user still has to accept a new version of the privacy policy or terms,
 * and in that case it brings the acceptance banner back (even if they hid it)
 * and says why, so a click that does nothing explains itself instead of
 * looking broken.
 *
 * Everything that is not an AI feature carries on working: this is the only
 * thing re-acceptance withholds.
 *
 * The frontend can only stop what a person starts here. Automatic transcription
 * of a recording is dispatched by the server, so the server has to refuse it
 * too — see the acceptance endpoint card for eesa-backend.
 */
export const aiFeaturesAllowed = () => {
    const legal = useLegalStore();

    if (!legal.aiBlocked) {
        return true;
    }

    legal.undismiss();

    showToast({
        icon: 'warning',
        title: 'One thing first',
        text: 'Please accept the updated privacy policy and terms to use the AI features.',
    });

    return false;
};
